
import { mapState } from 'vuex'
// import { throttle } from '~/utils/utils'
import wikiLoading from '~/components/common/wikiLoading.vue' // loading效果
import compareDetails from '~/components/compare/compareDetails'
import aiProblem from '~/components/compare/aiProblem'
import subNav from '~/components/common/subNav.vue'
import noData from '~/components/common/noData.vue'
import commonImg from '~/components/common/commonImg.vue'
import slideShow from '~/components/compare/slideShow'
import dealerModule from '@/components/dealer/head/dealerModule.vue'
import riskWarning from '@/components/dealer/head/riskWarning.vue'
import dealerTisk from '@/components/dealer/head/dealerTisk.vue'
import trader from '~/static/json/compareData.json'
import { debounce } from '~/utils/utils'
export default {
  name: 'DealerCompare',
  components: {
    'sub-nav': subNav,
    'no-data': noData,
    'common-img': commonImg,
    'slide-show': slideShow,
    'compare-details': compareDetails,
    'dealer-module': dealerModule,
    'risk-warning': riskWarning,
    'dealer-tisk': dealerTisk,
    'wiki-loading': wikiLoading,
    aiProblem
  },
  provide() {
    return {
      main: {},
      tips: this.tips // 风险提示
    }
  },
  async asyncData({ $api, app, store, route, res, $cookies, $serverlog, error }) {
    try {
      const compareRank = $api.home
        .invokev3data(
          {
            languageCode: store.state.LanguageCode,
            countryCode: store.state.CountryCode
          },
          {
            Routes: 'wikifx$traderexpandlist'
          }
        )
        .catch(() => {
          console.log('compare[asyncData],交易商对比rank接口错误')
        })

      let oldUrlNameList = (route && route.params && route.params.id && route.params.id.replace('.html', '').split('-vs-')) || []

      if ($cookies.get('compareAdCode') && oldUrlNameList.length <= 3) {
        oldUrlNameList = oldUrlNameList.filter((item) => item !== $cookies.get('compareAdCode'))
      }

      let excludeCodeList = []
      const excludeCode = []

      if (oldUrlNameList.length > 0) {
        excludeCodeList = await $api.compare.getUrlName({ codes: oldUrlNameList.toLocaleString() }).catch(() => {
          console.log('获取urlName错误,接口报错')
        })
      }

      if (excludeCodeList && excludeCodeList.length > 0)
        excludeCodeList.forEach((el) => {
          excludeCode.push(el?.TraderCode)
        })

      let hasAd = true
      let AdTrader = null
      let AdName = ''
      let AdCode = ''
      // console.log(excludeCode.toLocaleString(), 'toLocaleString()')
      if (oldUrlNameList.length < 3) {
        await $api.common
          .V3(
            {
              // 获取广告商的Code
              type: 860, // 固定参数
              excludeCode: excludeCode.toLocaleString()
            },
            {
              Routes: 'fxad$advertisementv2'
            }
          )
          .then(async (getAdCode) => {
            AdTrader = getAdCode.fxad?.advertisementv2?.data[0] // 广告obj
            AdCode = AdTrader?.code // 广告Code

            // console.log('AdCode::: ', AdTrader)
            AdName = null
            if (AdCode) {
              AdName = await $api.compare.getUrlName({ codes: AdCode }).catch(() => {
                console.log('获取AdName错误1')
              })
            }
            // url 去除.html,-vs- // 获取交易商urlName 和urlCodeList
            if (AdName && AdName[0]?.Name)
              $cookies.set('compareAdCode', AdName && AdName[0]?.Name, {
                path: '/',
                domain: store.state.cookieHost
              })
            hasAd = !oldUrlNameList.includes()
            if (AdName && AdName[0]?.Name) oldUrlNameList.push(AdName && AdName[0]?.Name)
          })
          .catch(() => {
            console.log('获取对比广告错误')
            res.statusCode = 404
            return {
              isShow404: true
            }
          })
      }
      const urlNameList = [...new Set(oldUrlNameList)]

      const rankList = []
      if (urlNameList.length === 0) {
        // 如果没有就干掉
        return Promise.all([compareRank]).then((result) => {
          const expandlist =
            result[0] && result[0].wikifx && result[0].wikifx.traderexpandlist && result[0].wikifx.traderexpandlist.data && result[0].wikifx.traderexpandlist.data.length > 0
              ? result[0].wikifx.traderexpandlist.data
              : []
          if (!expandlist || expandlist.length == 0) {
            console.log(404, '第一个')
            res.statusCode = 404
            return {
              isShow404: true
            }
          }
          console.log(expandlist, '对比排行榜', store.state.LanguageCode, store.state.CountryCode)
          expandlist &&
            expandlist.forEach((el) => {
              rankList.push({
                value: el.shortName,
                code: el.traderCode,
                ico: el.ico,
                logo: el.logo,
                name: el.localShortName
              })
            })
          return { rankList }
        })
      }

      const traderParams = trader
      // 3351410785 0361170645 0001378443 forex-com xm fxtm
      const codes = urlNameList.toLocaleString()
      let traderCodeList = []
      if (codes) {
        traderCodeList = await $api.compare.getUrlName({ codes }).catch(() => {
          console.log('获取urlName错误1')
        })
      }
      const urlCodeList = [] // 交易商 urlCodeList
      traderCodeList &&
        traderCodeList.forEach((el) => {
          urlCodeList.push(el.TraderCode)
        })
      if (urlNameList.length !== urlCodeList.length) {
        // console.log(urlNameList, urlCodeList)
        console.log(404, '第二个')
        res.statusCode = 404
        return {
          isShow404: true
        }
      }
      if (urlCodeList.length === 0) return
      const compareInit = $api.compare
        .compareInit({
          traderCodes: urlCodeList,
          ip: store.state.userIp,
          period: 2,
          isWeb: 1,
          platformType: 2,
          index: 1,
          size: 20
        })
        .catch(() => {
          console.log('compare,交易商对比init接口错误')
        })
      let atArrAll = []
      let atArr = []
      const atArr1 = []
      const atArr2 = []
      const atArr3 = []
      if (urlCodeList.length > 1) {
        const rankOne = traderParams.findIndex((item) => {
          return item.name == urlNameList[0]
        })

        const rankTwo = traderParams.findIndex((item) => {
          return item.name == urlNameList[1]
        })

        if (rankOne > rankTwo) {
          // console.log('rankOne > rankTwo')
        }
        const traderArr = traderParams.filter((item) => {
          return item.name != urlNameList[0] && item.name != urlNameList[1]
        })
        const mathIndex = rankTwo + 1
        atArrAll = traderArr.slice(mathIndex)
        if (urlCodeList.length == 3) {
          const rankThree = traderParams.findIndex((item) => {
            return item.name == urlNameList[2]
          })
          const traderArr = traderParams.filter((item) => {
            return item.name != urlNameList[0] && item.name != urlNameList[1] && item.name != urlNameList[2]
          })
          const mathIndex = rankThree + 1
          atArrAll = traderArr.slice(mathIndex)
        }
        atArrAll &&
          atArrAll.slice(0, 6).forEach((el) => {
            atArr1.push({
              code: el.code,
              name: el.name,
              urlName: urlNameList[0]
            })
            atArr2.push({
              code: el.code,
              name: el.name,
              urlName: urlNameList[1]
            })
            if (urlNameList[2]) {
              atArr3.push({
                code: el.code,
                name: el.name,
                urlName: urlNameList[2]
              })
            }
          })
      }
      atArr = [...atArr1, ...atArr2, ...atArr3]
      const elUrlNameList = []
      urlNameList &&
        urlNameList.forEach((el) => {
          elUrlNameList.push({
            urlName: el
          })
        })
      const tipsmodule = $api.dealer.tips().catch(() => {}) // 风险提示

      return Promise.all([compareInit, compareRank, tipsmodule]).then((result) => {
        if (!result[0]) {
          console.log('compare,交易商对比init接口错误---------error')
          res.statusCode = 404
          return {
            isShow404: true
          }
        }
        const list = [{}, {}, {}]
        const traderInfo = result[0].TraderInfoResponse || []
        const infoData = result[0].TradeBrokersContrastResponse || []
        const traderCount = result[0].TraderCountResponse.items || []
        const exposedTraderList = result[0].ExposedTraderList || []
        const MultipleTrader = result[0].MultipleTrader || []
        const TraderArticles = result[0].TraderArticles || []
        const TraderIntros = result[0].TraderIntros || []
        // 排行榜
        const expandlist =
          result[1] && result[1].wikifx && result[1].wikifx.traderexpandlist && result[1].wikifx.traderexpandlist.data && result[1].wikifx.traderexpandlist.data.length > 0
            ? result[1].wikifx.traderexpandlist.data
            : []
        // console.log(expandlist, 9997)
        if (expandlist && expandlist.length > 0) {
          expandlist.forEach((el) => {
            rankList.push({
              value: el.shortName,
              code: el.traderCode || el.code,
              ico: el.ico,
              logo: el.logo,
              name: el.localShortName,
              hitsInfo: el.hitsInfo
            })
          })
        }
        const exposedTotal = []
        // 天眼曝光
        exposedTraderList.forEach((el) => {
          // console.log(el, 'el123')
          exposedTotal.push({ exposedTotal: el.count })
        })
        const traderlist = traderInfo.map((item, index) => {
          return {
            ...elUrlNameList[index],
            ...infoData[index],
            ...MultipleTrader[index],
            ...TraderArticles[index],
            ...TraderIntros[index],
            ...traderCount[index],
            ...exposedTotal[index],
            ...item
          }
        })
        //
        const dealerNameList = []
        traderlist &&
          traderlist.forEach((el, i) => {
            const emptyLlist = []
            el.accounts &&
              el.accounts.forEach((val) => {
                emptyLlist.push(val.accountName)
              })
            // shortName 放前面  localShortName放后面
            if (el.localshortname == el.shortName) {
              dealerNameList.push(el.shortName || el.localshortname)
            } else {
              dealerNameList.push(`${el.shortName || ''} ${el.localshortname || ''}`)
            }
            const licensesList = []
            el.basic &&
              el.basic.licenses &&
              el.basic.licenses.forEach((item) => {
                licensesList.push(item.shortName)
              })
            // console.log(el, '数据数据')
            list.splice(i, 1, {
              shortName: el.shortName,
              localshortname: el.localshortname,
              icon: el.icon, // ico
              urlName: el.urlName, // urlName
              content: el.content,
              summary: el.summary,
              TraderArticles: el.TraderArticles || null,
              MultipleTrader: el.MultipleTraderExposure || null,
              exposedTotal: el.exposedTotal || 0,
              surveyList: el.list || [],
              code: el.code || el.TraderCode,
              logo: el.logo,
              // 天眼评分
              score: ((el.rating && el.rating.score) * 1).toFixed(2) || '--',
              status: (el.rating && el.rating.status) || '--',
              isEPC: el?.rating.isEPC == 'true' ? '保障中' : '无保障',
              risk: (el.rating && el.rating.risk) || 0,
              webSite: el.rating.webSite || '--', // 网址
              // 基本信息
              established: el.basic.established || '--',
              licensesItems: licensesList.toString() || '--',
              existmt4: el.basic.existmt4.toString() == 'true' ? 1 : 0,
              existmt5: el.basic.existmt5.toString() == 'true' ? 1 : 0,
              existcurrency: el.basic.existcurrency.toString() == 'true' ? 1 : 0,
              methods: el.basic.methods || '--',
              // 交易环境
              Grade: el.Grade || '--',
              SpeedGrade: el.SpeedGrade || '--',
              AveSpeed: el.AveSpeed || '--',
              FastestSpeed: el.FastestSpeed || '--',
              FastestSpeed_Open: el.FastestSpeed_Open || '--',
              FastestSpeed_Close: el.FastestSpeed_Close || '--',
              SlowestSpeed: el.SlowestSpeed || '--',
              SlowestSpeed_Open: el.SlowestSpeed_Open || '--',
              SlowestSpeed_Close: el.SlowestSpeed_Close || '--',
              // 交易滑点
              SlipGrade: el.SlipGrade || '--',
              AveSlip_wh: el.AveSlip_wh || '--',
              AveSlip_xau: el.AveSlip_xau || '--',
              MaxSlip: el.MaxSlip || '--',
              MaxSlip_Positive: el.MaxSlip_Positive || '--',
              MaxSlip_Negative: el.MaxSlip_Negative || '--',
              // 交易成本
              CostGrade: el.CostGrade || '--',
              AveCost_wh: el.AveCost_wh ? 'EURUSD：' + el.AveCost_wh : '--',
              AveCost_xau: el.AveCost_xau ? 'XAUUSD：' + el.AveCost_xau : '--',
              // 隔夜成本
              SwapGrade: el.SwapGrade || '--',
              AveLongSwap_wh: el.AveLongSwap_wh || '--',
              AveShortSwap_wh: el.AveShortSwap_wh || '--',
              AveLongSwap_xau: el.AveLongSwap_xau || '--',
              AveShortSwap_xau: el.AveShortSwap_xau || '--',
              // 断线情况
              OffLineGrade: el.OffLineGrade || '--',
              AveReconnectNum: el.AveReconnectNum || '--',
              AveReconnectTime: el.AveReconnectTime || '--',
              // 账户信息
              accountName: (el.accounts && el.accounts[0] && el.accounts[0].accountName) || '--',
              allAccounts: el.accounts || [
                {
                  accountName: '--',
                  transactionType: '--',
                  enterCondition: '--',
                  maxLever: '--',
                  mainSpread: '--',
                  outStockRatio: '--',
                  spreadType: '--',
                  minCash: '--',
                  allowLock: '--',
                  allowScalping: '--',
                  allowEA: '--',
                  cryptocurrency: '--'
                }
              ], // 数组 所有账户
              allName: emptyLlist.toString() || '--',
              AdSlogan: hasAd && el.code == AdCode ? AdTrader.slogan || 'AD' : null,
              hitsInfo: hasAd && el.code == AdCode ? AdTrader.hitsInfo : null
            })
          })

        let TDKName = null
        let TDKList = null
        try {
          TDKName = JSON.parse(JSON.stringify(dealerNameList))
          TDKList = JSON.parse(JSON.stringify(urlNameList))
        } catch {}

        return {
          urlCodeList,
          list,
          urlNameList,
          rankList,
          traderInfo,
          infoData,
          traderCount,
          atArr,
          dealerNameList,
          AdTrader,
          ADobj: AdName,
          hasAd,
          TDKName,
          TDKList,
          tips: result?.[2] || {} // 风险提示
        }
      })
    } catch (err) {
      $serverlog(error(err).message)
    }
  },
  data() {
    return {
      hasAd: false,
      ADobj: null,
      surveyObj: {
        show: false,
        cover: '',
        name: ''
      },
      isSurveyCoverPopUpShow: false, // 实勘图片弹出框
      surveyCover: '',
      mobile: {
        // 只有在手机模式下才有的关闭默认的模块
        grade: true,
        env: true,
        aInfo: true
      },
      mobileSearchValue: '',
      AdTrader: null,
      methodsItemHeight: 60,
      autoSerarchValue: '', // 侧边栏新的搜索值
      isLastTrader: false, // 是否是最后一个交易商,唯一一个交易商隐藏删除Btn
      hiddenElement: false, // 隐藏相同的参数
      highlightELement: false, // 高亮不同的参数
      dealerNameList: [], // 交易商名称List
      scrolleds: 0, // 滚动的高度
      isShowMobileTabList: false,
      loading: false, // 触发loading
      autocompleteValue: ['', '', '', '', ''],
      scroll_new: true, // 滚动条
      isPinnedLeft: false, // 是否钉在左侧
      isPinnedLeftCode: '', // 被盯住的code
      pinnedLeftIndex: 0, // 被钉住的索引
      urlCodeList: [],
      urlNameList: [],
      rankList: [], // 排行默认
      navData: [
        // 导航数据
        { link: '/', text: '首页', type: 'a', full: true },
        { link: '/compare', text: '交易商对比', type: 'span' }
      ],
      tabList: [
        // tabs
        { name: this.$v('天眼评级'), link: 'first-floor', type: 0 },
        { name: this.$v('基本信息'), link: 'second-floor', type: 1 },
        { name: this.$v('交易环境'), link: 'third-floor', type: 2 },
        { name: this.$v('账户信息'), link: 'fourth-floor', type: 3 }
      ],
      isActived: 0, // tabList的选择,默认第一条
      isShow404: false, // 是否展示404
      dealerName: [], // 交易商名称
      tabIndex: 0, // 默认选择0
      list: [{}, {}, {}],
      traderInfo: [],
      infoData: [],
      traderCount: null,
      exposedTraderList: [],
      UrlName: null, // 被
      accountName: '',
      accountsIndex: [0, 0, 0], // 账户信息
      atArr: [], // 对比页面的数据
      selector: 'second-floor',
      isHidden: {
        // 隐藏相同的数据
        grade: {
          // 天眼评级
          score: true,
          status: true,
          isEPC: true,
          surveyList: true,
          risk: true,
          exposedTotal: true,
          webSite: true
        },
        bInfo: {
          // 基本信息
          established: true,
          licensesItems: true,
          existmt4: true,
          existmt5: true,
          existcurrency: true,
          methods: true
        },
        env: {
          Grade: true,
          SpeedGrade: true,
          AveSpeed: true,
          FastestSpeed: true,
          FastestSpeed_Open: true,
          FastestSpeed_Close: true,
          SlowestSpeed: true,
          SlowestSpeed_Open: true,
          SlowestSpeed_Close: true,
          SlipGrade: true,
          AveSlip: {
            // AveSlip_wh  AveSlip_xau
            wh: true,
            xau: true
          },
          MaxSlip: true,
          MaxSlip_Positive: true,
          MaxSlip_Negative: true,
          CostGrade: true, // 交易成本评级
          // AveCost_wh  AveCost_xau
          AveCost: {
            wh: true,
            xau: true
          },
          SwapGrade: true,
          // AveLongSwap_wh AveShortSwap_wh AveLongSwap_xau AveShortSwap_xau
          AveLongSwap: {
            wh: true,
            xau: true
          },
          AveShortSwap: {
            wh: true,
            xau: true
          },
          OffLineGrade: true,
          AveReconnectNum: true,
          AveReconnectTime: true
        },
        aInfo: {
          allName: true,
          accountName: true,
          transactionType: true,
          enterCondition: true,
          maxLever: true,
          mainSpread: true,
          outStockRatio: true,
          spreadType: true,
          minCash: true,
          cryptocurrency: true,
          allowLock: true,
          allowScalping: true,
          allowEA: true
        },
        TDKName: [],
        TDKList: []
      },
      companyWebsite: '', // 交易商官网链接
      returnWebsite: '', // 回调网址
      tips: {}, // 风险提示
      moduleShow: false, // 是否显示自定义弹框
      modelShow: false, // 是否显示弹框蒙层
      tipsType: '', // 弹框提示类型
      headshow: false,
      isAiUnfold: true,
      aiData: null,
      isAiPopShow: false,
      isAiLoad: false,
      isAiLike: false, // ai 是否点赞
      isFeedback: false, // ai弹框是否展开
      dealerNameCodeList: [],
      feedbackList: [], // 弹框中的反馈列表
      isGetAiDataLoading: false, // 判断ai接口数据是否可以触发
      // 防抖计时器
      getAiDataDebounceTimer: null, // 获取ai数据防抖(产品规定要加上4秒的延迟) 
      // 屏幕宽度相关
      screenWidth: 0,
      firstFloorRef: null,
      isAicontentShow: false // ai内容模块是否显示
    }
  },
  head() {
    const IS_EN_CN = ['zh-cn', 'en'].includes(this.LanguageCode)
    const dealerNames = this.dealerNameList
    let title
    let content

    if (IS_EN_CN) {
      if (dealerNames.length === 3) {
        title = this.$t('62873')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}', dealerNames[1] || '')
          .replace('{2}', dealerNames[2] || '')

        content = this.$t('62872')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}', dealerNames[1] || '')
          .replace('{2}', dealerNames[2] || '')
      } else if (dealerNames.length === 2) {
        title = this.$t('62873')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}、', dealerNames[1] || '')
          .replace('{1}, and', dealerNames[1] || '')
          .replace('{2}', '')

        content = this.$t('62872')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}和', dealerNames[1] || '')
          .replace('{1}, and', dealerNames[1] || '')
          .replace('{2}', '')
      } else {
        title = this.$t('33636')
        content = this.$t('33637')
      }
    } else {
      title = this.$t('33636')
      content = this.$t('33637')
    }

    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.googlenav(this.navData)
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      LanguageCode: 'LanguageCode',
      fatherDomain: 'fatherDomain'
    }),
    // 导航栏
    setTabList() {
      // 基础tab列表，包含所有场景都需要的选项卡
      const baseTabs = [
        // { name: `AI${this.$v('对比总结')}`, link: 'first-floor', type: 0 },
        { name: this.$v('天眼评级'), link: 'second-floor', type: 1 },
        { name: this.$v('基本信息'), link: 'third-floor', type: 2 },
        { name: this.$v('交易环境'), link: 'fourth-floor', type: 3 },
        { name: this.$v('账户信息'), link: 'fifth-floor', type: 4 }
      ]

      // 判断是否有资讯内容
      const hasArticles = this.TraderArticles.length > 0 || this.TraderArticles1.length > 0 || this.TraderArticles2.length > 0
      // 判断是否有曝光内容
      const hasExposures = this.MultipleTrader.length > 0 || this.MultipleTrader1.length > 0 || this.MultipleTrader2.length > 0

      // 根据条件动态构建tab列表
      if (hasArticles && hasExposures) {
        // 同时有资讯和曝光，两者都显示
        return [...baseTabs, { name: this.$v('相关资讯'), link: 'six-floor', type: 5 }, { name: this.$v('相关曝光'), link: 'seven-floor', type: 6 }]
      } else if (hasArticles) {
        // 只有资讯
        return [...baseTabs, { name: this.$v('相关资讯'), link: 'six-floor', type: 5 }]
      } else if (hasExposures) {
        // 只有曝光
        return [...baseTabs, { name: this.$v('相关曝光'), link: 'six-floor', type: 6 }]
      }

      // 默认返回基础tab列表
      return baseTabs
    },

    TraderArticles() {
      return (this.list && this.list[0] && this.list[0].TraderArticles) || []
    },
    TraderArticles1() {
      return (this.list && this.list[1] && this.list[1].TraderArticles) || []
    },
    TraderArticles2() {
      return (this.list && this.list[2] && this.list[2].TraderArticles) || []
    },
    MultipleTrader() {
      return (this.list && this.list[0] && this.list[0].MultipleTrader) || []
    },
    MultipleTrader1() {
      return (this.list && this.list[1] && this.list[1].MultipleTrader) || []
    },
    MultipleTrader2() {
      return (this.list && this.list[2] && this.list[2].MultipleTrader) || []
    },
    totalDealer() {
      // const NumArr = []
      // this.list.forEach((el) => { if (el.shortName) NumArr.push(el.shortName) })
      const span = `<span>&nbsp;<span style="color:#DE7032">${this.urlCodeList.length}</span>&nbsp;</span>`
      const mibileSpan = `<span><span style="color:#DE7032">${this.urlCodeList.length}</span></span>` // H5样式
      return (this.isMobile ? this.$v('共 {0} 条交易商') : this.$v('共 {0} 条交易商')).replace('{0}', this.isMobile ? mibileSpan : span)
    },
    isLongLanguage() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh') return false
      else return true
    },

    // isLastTrader () { // 是否是最后一个交易商,唯一一个交易商隐藏删除Btn
    //   const NumArr = []
    //   this.list.forEach((el) => { if (el.shortName) NumArr.push(el.shortName) })
    //   if (NumArr.length < 2) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
    aInfoAccountList() {
      // 交易环境的list
      let arr = []
      if (this.urlCodeList.length < 2) return arr

      if (this.list && this.list[2].code) {
        arr = [this.list[0].allAccounts[this.accountsIndex[0]] || {}, this.list[1].allAccounts[this.accountsIndex[1]] || {}, this.list[2].allAccounts[this.accountsIndex[2]] || {}]
      } else {
        arr = [this.list[0].allAccounts[this.accountsIndex[0]] || {}, this.list[1].allAccounts[this.accountsIndex[1]] || {}]
      }
      return arr
    },

    isOverflowAuto() {
      return this.urlCodeList.length == 3 && this.isMobile
    },
    // 处理overview中的交易商名称并添加a标签链接
    processedOverview() {
      if (!this.aiData?.overview) {
        return ''
      }

      let processedItem = this.aiData?.overview

      // 如果有dealerNameCodeList，则为每个交易商名称添加a标签链接
      if (this.dealerNameCodeList && Array.isArray(this.dealerNameCodeList)) {
        this.dealerNameCodeList.forEach((dealer) => {
          if (dealer.name && dealer.traderCode) {
            // 创建正则表达式，使用全局匹配，忽略大小写
            const regex = new RegExp(`\\b${this.escapeRegExp(dealer.name)}\\b`, 'gi')
            // 替换为带有a标签的内容
            processedItem = processedItem.replace(
              regex,
              `<a href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${dealer.traderCode}" target="_blank" class="text-[#1558BC] hover:underline">${dealer.name}</a>`
            )
          }
        })
      }

      return processedItem
    },
    // 处理recommendations数组中每个项并添加a标签链接
    processedRecommendations() {
      if (!this.aiData?.recommendations || !Array.isArray(this.aiData.recommendations)) {
        return []
      }
      return this.aiData?.recommendations
      // 选择建议的数据 添加a标签链接功能暂时注释掉（后面有可能还会加）
      // // 处理数组中每个推荐内容
      // return this.aiData.recommendations.map((item) => {
      //   let processedItem = item

      //   // 如果有dealerNameCodeList，则为每个交易商名称添加a标签链接
      //   if (this.dealerNameCodeList && Array.isArray(this.dealerNameCodeList)) {
      //     this.dealerNameCodeList.forEach((dealer) => {
      //       if (dealer.name && dealer.traderCode) {
      //         // 创建正则表达式，使用全局匹配，忽略大小写
      //         const regex = new RegExp(`\\b${this.escapeRegExp(dealer.name)}\\b`, 'gi')
      //         // 替换为带有a标签的内容
      //         processedItem = processedItem.replace(
      //           regex,
      //           `<a href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${dealer.traderCode}" target="_blank" class="text-[#1558BC] hover:underline">${dealer.name}</a>`
      //         )
      //       }
      //     })
      //   }

      //   return processedItem
      // })
    }
  },
  watch: {
    list: {
      // 监听实际值隐藏和现实iconX
      handler(v) {
        this.isAiUnfold = true // 只要list 发生变化 isAiUnfold 置为true 未展开的状态
        const arr = []
        v.forEach((el) => {
          if (el.code) arr.push(el.code)
          this.dealerNameCodeList.push({
            name: el.shortName || el.localshortname,
            traderCode: el.code
          })
        })
        if (arr.length == 0) return
        this.$nextTick(() => {
          if (Array.isArray(this.$refs.aiEBlock)) {
            this.$refs.aiEBlock.forEach((block) => {
              block.style.height = ''
            })
          }
        })
        if (arr.length < 2) {
          this.isLastTrader = false
          this.isAicontentShow = false
          if (this.hiddenElement) {
            this.changeDom(false)
            this.hiddenElement = false
          }
        } else {
          this.isLastTrader = true
          this.isAicontentShow = true
        }

        if (v.length > 3) this.list.slice(0, 3)
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.isMobile) {
      this.mobile.grade = false
      this.mobile.env = false
      this.mobile.aInfo = false
    }
  },
  mounted() {
    // this.loadScript()
    this.initAiData()
    // this.$message.info(this.hasAd ? `有广告${this.ADobj[0].TraderCode}--${this.ADobj[0].Name},国家:${this.$store.state.CountryCode}` : '无广告')
    const container = document.getElementById('details-box')
    const newDiv = document.getElementById('newD')
    if (!container) return
    if (this.AdTrader && this.urlCodeList.length < 4) this.addUrlName('any', this.AdTrader.code, true)
    window.addEventListener('scroll', debounce(this.onScrolls, 100), {
      passive: true
    })
    // 添加屏幕宽度相关初始化
    this.screenWidth = window.innerWidth
    this.firstFloorRef = document.getElementById('first-floor')
    this.handleResize()
    window.addEventListener('resize', this.handleResize)

    if (!this.isMobile) {
      newDiv.getElementsByClassName('dealer-info-container')[0].addEventListener(
        'scroll',
        function () {
          container.getElementsByClassName('dealer-info-container')[0].scrollLeft = newDiv.getElementsByClassName('dealer-info-container')[0].scrollLeft
        },
        { passive: true }
      )
      container.parentNode.insertBefore(newDiv, container.nextSibling)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrolls)
    // 移除屏幕大小监听
    window.removeEventListener('resize', this.handleResize)
    // 清除防抖计时器
    if (this.getAiDataDebounceTimer) {
      clearTimeout(this.getAiDataDebounceTimer)
    }
  },
  methods: {
    // 转义正则表达式特殊字符
    escapeRegExp(val) {
      return val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },
    // 处理屏幕大小变化
    handleResize() {
      this.screenWidth = window.innerWidth
      this.updateFirstFloorWidth()
    },
    // 更新first-floor元素的宽度
    updateFirstFloorWidth() {
      if (!this.firstFloorRef) {
        this.firstFloorRef = document.getElementById('first-floor')
      }
      
      if (this.firstFloorRef && this.screenWidth < 800) { // 根据项目断点定义，sm断点是小于800px
        // 小屏幕情况下，设置为当前屏幕宽度
        this.firstFloorRef.style.width = `${this.screenWidth}px`
        
        // 同时更新子容器的宽度
        const childContainer = this.firstFloorRef.querySelector('.border')
        if (childContainer) {
          childContainer.style.width = `${this.screenWidth}px`
        }
      } else if (this.firstFloorRef) {
        // 大屏幕情况下，移除内联样式，使用CSS类定义的宽度
        this.firstFloorRef.style.width = ''
        
        // 同时移除子容器的内联样式
        const childContainer = this.firstFloorRef.querySelector('.border')
        if (childContainer) {
          childContainer.style.width = ''
        }
      }
    },
    // 点踩方法
    aiPopClick() {
      if (this.isFeedback) {
        this.isFeedback = false
        this.$api.common
          .CV3(
            {
              id: this.aiData.id,
              like: false,
              feedback_type: [],
              content: '',
              cancel: true
            },
            {
              Routes: 'wikiai$v1aitradercomparisonfeedback'
            }
          )
          .then((res) => {})
      } else {
        this.isAiPopShow = true
      }
    },
    // 加载失败 重新加载生成数据接口
    afreshLoad () {
      this.initAiData()
    },
    // ai 数据处理
    initAiData() {
      const validList = this.list.length >= 3 ? (!this.list[2].shortName ? this.list.slice(0, 2) : this.list) : this.list
      const tempList = this.generateMultiBrokerComparison(validList)
      this.getAiData(tempList)
    },
    submitSuccess(obj) {
      const { selectedTypes, textarea } = obj
      const _list = []
      selectedTypes.forEach((item) => {
        _list.push(item.type)
      })
      this.$api.common
        .CV3(
          {
            id: this.aiData.id,
            like: false,
            feedback_type: _list,
            content: textarea
          },
          {
            Routes: 'wikiai$v1aitradercomparisonfeedback'
          }
        )
        .then((res) => {
          this.isAiPopShow = false
          this.isFeedback = true
          this.isAiLike = false // 点踩成功之后点赞需要（只修改状态即可 后端会去记录）
        })
    },
    likeClick() {
      this.isAiLike = !this.isAiLike
      if (this.isAiLike) {
        this.isFeedback = false
      }
      this.$api.common
        .CV3(
          {
            id: this.aiData.id,
            like: this.isAiLike,
            feedback_type: [],
            content: '',
            cancel: !this.isAiLike
          },
          {
            Routes: 'wikiai$v1aitradercomparisonfeedback'
          }
        )
        .then((res) => {})
    },
    loadScript() {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://resources1.interface003.com/web20/js/lottie.min.js'
      document.body.insertBefore(script, document.body.firstChild)
      script.onload = () => {
        window.lottie.loadAnimation({
          container: document.getElementById('ai-json'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: 'https://resources1.interface003.com/web20/img/ai/data22.json'
        })
      }
    },
    unfoldClick(val) {
      this.isAiUnfold = val
      this.$nextTick(() => {
        // 遍历所有aiEBlock元素进行赋值
        if (Array.isArray(this.$refs.aiEBlock)) {
          this.$refs.aiEBlock.forEach((block) => {
            block.style.height = this.$refs.comparisonDom.offsetHeight + 64 + 'px'
          })
        }
      })
    },
    // 格式化数据
    generateMultiBrokerComparison(rawDataArray) {
      if (!Array.isArray(rawDataArray) || rawDataArray.length === 0) {
        return { rows: [] }
      }
      // 辅助函数：将值转换为字符串，并将--转换为空字符串
      const formatValue = (value) => {
        if (value === null || value === undefined) return ''
        const strValue = value.toString()
        return strValue === '--' ? '' : strValue
      }

      // 处理单个交易商数据的函数 - 严格按照45个字段
      const processBrokerData = (data) => {
        return {
          // 基础信息 (14个)
          交易商名称: formatValue(data.shortName),
          天眼评分: formatValue(data.score),
          监管状态: formatValue(data.status),
          天眼保障: formatValue(data.isEPC),
          天眼实勘: data.surveyList?.length ? `${this.getSurvey(data.surveyList[0].evaluatecode, data.surveyList[0].count)}` : '',
          风险测评: '0条', // 这个字段在原始数据中没有，固定值
          天眼曝光: formatValue(data.exposedTotal) || '0',
          官网链接: formatValue(data.webSite),
          '成立时间(年)': formatValue(data.established),
          监管牌照: formatValue(data.licensesItems),
          MT4: data.existmt4 ? '支持' : '不支持',
          MT5: data.existmt5 ? '支持' : '不支持',
          加密货币: data.existcurrency ? '支持' : '不支持',
          出入金方式: formatValue(data.methods),

          // 交易环境评级 (7个)
          交易环境评级: formatValue(data.Grade),
          交易速度评级: formatValue(data.SpeedGrade),
          平均交易速度: formatValue(data.AveSpeed),
          最快交易速度: formatValue(data.FastestSpeed),
          开仓最快速度: formatValue(data.FastestSpeed_Open),
          平仓最快速度: formatValue(data.FastestSpeed_Close),
          平仓最慢速度: formatValue(data.SlowestSpeed_Close),

          // 交易滑点评级 (5个)
          交易滑点评级: formatValue(data.SlipGrade),
          平均滑点: formatSlipData(formatValue(data.AveSlip_wh), formatValue(data.AveSlip_xau)),
          最大交易滑点: formatValue(data.MaxSlip),
          最大正滑点: formatValue(data.MaxSlip_Positive),

          // 交易成本评级 (3个)
          交易成本评级: formatValue(data.CostGrade),
          平均交易成本: formatCostData(formatValue(data.AveCost_wh), formatValue(data.AveCost_xau)),

          // 隔夜成本评级 (2个)
          隔夜成本评级: formatValue(data.SwapGrade),
          平均隔夜成本: formatSwapData(data),

          // 软件断线评级 (3个)
          软件断线评级: formatValue(data.OffLineGrade),
          '平均断线频率（次/天）': formatValue(data.AveReconnectNum),
          断线重连时间: formatValue(data.AveReconnectTime),

          // 账户信息 (11个)
          账户类型: formatValue(data.allName),
          账户名称: formatValue(data.accountName),
          交易品种: data.content ? extractInstruments(data.content) : '',
          入金要求: extractMinDeposit(data.content) || '',
          最大杠杆: formatValue(data.allAccounts?.[0]?.maxLever),
          主要点差: formatValue(data.allAccounts?.[0]?.mainSpread),
          爆仓比例: formatValue(data.allAccounts?.[0]?.outStockRatio),
          点差类型: formatValue(data.allAccounts?.[0]?.spreadType),
          最小头寸: formatValue(data.allAccounts?.[0]?.minCash),
          锁仓: data.allAccounts?.[0]?.allowLock === 'true' ? '允许' : '不允许',
          剥头皮: data.allAccounts?.[0]?.allowScalping === 'true' ? '允许' : '不允许',
          EA交易: data.allAccounts?.[0]?.allowEA === 'true' ? '允许' : '不允许'
        }
      }

      // 辅助函数：格式化滑点数据
      const formatSlipData = (wh, xau) => {
        if (!wh && !xau) return ''
        return `EURUSD：${wh || '0.0'}\nXAUUSD：${xau || '0.0'}`
      }

      // 辅助函数：格式化成本数据
      const formatCostData = (wh, xau) => {
        if (!wh && !xau) return ''
        return `EURUSD：${wh || '0.0'}\nXAUUSD：${xau || '0.0'}`
      }

      // 辅助函数：格式化隔夜成本数据
      const formatSwapData = (data) => {
        const longWH = data.AveLongSwap_wh == '--' ? '' : data.AveLongSwap_wh
        const shortWH = data.AveShortSwap_wh == '--' ? '' : data.AveShortSwap_wh
        const longXAU = data.AveLongSwap_xau == '--' ? '' : data.AveLongSwap_xau
        const shortXAU = data.AveShortSwap_xau == '--' ? '' : data.AveShortSwap_xau
        return `EURUSD：${longWH}~${shortWH}\nXAUUSD：${longXAU}~${shortXAU}`
      }

      // 从content中提取交易品种的辅助函数
      const extractInstruments = (content) => {
        if (!content) return ''
        const match = content.match(/市场工具<\/b>[\s\S]*?<\/p>\s*<p>([^<]+)/)
        return match ? match[1].trim() : ''
      }

      // 从content中提取最低入金的辅助函数
      const extractMinDeposit = (content) => {
        if (!content) return ''
        const match = content.match(/最低存款<\/td>\s*<td[^>]*>([^<]+)/)
        return match ? match[1].trim() : ''
      }

      // 处理所有交易商数据
      const processedBrokers = rawDataArray.map(processBrokerData)

      // 严格按照45个字段顺序生成对比rows
      const rows = [
        { name: '交易商名称', values: processedBrokers.map((broker) => broker['交易商名称']) },
        { name: '天眼评分', values: processedBrokers.map((broker) => broker['天眼评分']) },
        { name: '监管状态', values: processedBrokers.map((broker) => broker['监管状态']) },
        { name: '天眼保障', values: processedBrokers.map((broker) => broker['天眼保障']) },
        { name: '天眼实勘', values: processedBrokers.map((broker) => broker['天眼实勘']) },
        { name: '风险测评', values: processedBrokers.map((broker) => broker['风险测评']) },
        { name: '天眼曝光', values: processedBrokers.map((broker) => broker['天眼曝光']) },
        { name: '官网链接', values: processedBrokers.map((broker) => broker['官网链接']) },
        { name: '成立时间(年)', values: processedBrokers.map((broker) => broker['成立时间(年)']) },
        { name: '监管牌照', values: processedBrokers.map((broker) => broker['监管牌照']) },
        { name: 'MT4', values: processedBrokers.map((broker) => broker.MT4) },
        { name: 'MT5', values: processedBrokers.map((broker) => broker.MT5) },
        { name: '加密货币', values: processedBrokers.map((broker) => broker['加密货币']) },
        { name: '出入金方式', values: processedBrokers.map((broker) => broker['出入金方式']) },
        { name: '交易环境评级', values: processedBrokers.map((broker) => broker['交易环境评级']) },
        { name: '交易速度评级', values: processedBrokers.map((broker) => broker['交易速度评级']) },
        { name: '平均交易速度', values: processedBrokers.map((broker) => broker['平均交易速度']) },
        { name: '最快交易速度', values: processedBrokers.map((broker) => broker['最快交易速度']) },
        { name: '开仓最快速度', values: processedBrokers.map((broker) => broker['开仓最快速度']) },
        { name: '平仓最快速度', values: processedBrokers.map((broker) => broker['平仓最快速度']) },
        { name: '平仓最慢速度', values: processedBrokers.map((broker) => broker['平仓最慢速度']) },
        { name: '交易滑点评级', values: processedBrokers.map((broker) => broker['交易滑点评级']) },
        { name: '平均滑点', values: processedBrokers.map((broker) => broker['平均滑点']) },
        { name: '最大交易滑点', values: processedBrokers.map((broker) => broker['最大交易滑点']) },
        { name: '最大正滑点', values: processedBrokers.map((broker) => broker['最大正滑点']) },
        { name: '交易成本评级', values: processedBrokers.map((broker) => broker['交易成本评级']) },
        { name: '平均交易成本', values: processedBrokers.map((broker) => broker['平均交易成本']) },
        { name: '隔夜成本评级', values: processedBrokers.map((broker) => broker['隔夜成本评级']) },
        { name: '平均隔夜成本', values: processedBrokers.map((broker) => broker['平均隔夜成本']) },
        { name: '软件断线评级', values: processedBrokers.map((broker) => broker['软件断线评级']) },
        { name: '平均断线频率（次/天）', values: processedBrokers.map((broker) => broker['平均断线频率（次/天）']) },
        { name: '断线重连时间', values: processedBrokers.map((broker) => broker['断线重连时间']) },
        { name: '账户类型', values: processedBrokers.map((broker) => broker['账户类型']) },
        { name: '账户名称', values: processedBrokers.map((broker) => broker['账户名称']) },
        { name: '交易品种', values: processedBrokers.map((broker) => broker['交易品种']) },
        { name: '入金要求', values: processedBrokers.map((broker) => broker['入金要求']) },
        { name: '最大杠杆', values: processedBrokers.map((broker) => broker['最大杠杆']) },
        { name: '主要点差', values: processedBrokers.map((broker) => broker['主要点差']) },
        { name: '爆仓比例', values: processedBrokers.map((broker) => broker['爆仓比例']) },
        { name: '点差类型', values: processedBrokers.map((broker) => broker['点差类型']) },
        { name: '最小头寸', values: processedBrokers.map((broker) => broker['最小头寸']) },
        { name: '锁仓', values: processedBrokers.map((broker) => broker['锁仓']) },
        { name: '剥头皮', values: processedBrokers.map((broker) => broker['剥头皮']) },
        { name: 'EA交易', values: processedBrokers.map((broker) => broker['EA交易']) }
      ]

      // 验证字段数量
      console.log(`processBrokerData内部字段数: ${Object.keys(processedBrokers[0]).length}`)
      console.log(`最终生成的对比条目数: ${rows.length}`)

      return { rows }
    },
    adfn(item) {
      console.log(item, 887)
      this.adcountfn(item.hitsInfo)
    },
    tdkTitle() {
      if (this.TDKName?.length == 0 || this.TDKList?.lenght == 0) return ''
      const name = this.TDKName && this.TDKName[0]
      const name1 = this.TDKName && this.TDKName[1]
      const name2 = this.TDKName && this.TDKName[2]
      if (this.TDKList && this.TDKList[2]) {
        return this.$t('22385').replace('{1}', name).replace('{2}', name1).replace('{3}', name2)
      }
      if (this.TDKList && this.TDKList[1]) {
        return this.$t('22385')
          .replace('{1}', name)
          .replace('{2}', name1)
          .replace('vs {3}', '')
          .replace('กับ {3}', '')
          .replace('và {3}', '')
          .replace('と{3}', '')
          .replace('и {3}', '')
          .replace('{3} مقارنة', '')
          .replace('{3}', name2)
      } else {
        return ''
      }
    },
    tdkContent() {
      if (this.TDKName?.length == 0 || this.TDKList?.lenght == 0) return ''
      const name = this.TDKName && this.TDKName[0]
      const name1 = this.TDKName && this.TDKName[1]
      const name2 = this.TDKName && this.TDKName[2]
      if (this.TDKList && this.TDKList[2]) {
        return this.$t('22386').replace('{1}', name).replace('{2}', name1).replace('{3}', name2)
      }
      if (this.TDKList && this.TDKList[1]) {
        return this.$t('22386')
          .replace('{1}', name)
          .replace('{2}', name1)
          .replace('vs {3}', '')
          .replace('กับ {3}', '')
          .replace('và {3}', '')
          .replace('と{3}', '')
          .replace('и {3}', '')
          .replace('مقابل {3}', '')
          .replace('{3}', name2)
      } else {
        return ''
      }
    },
    spliceStr(str) {
      if (!str) return
      const index = str?.indexOf('?') // 找到第一个?的位置
      if (index != -1) return str.substring(0, index)
      else return str
    },
    openBottomPopUp(item, name) {
      if (this.isMobile) {
        this.surveyObj.cover = item.cover
        this.surveyObj.name = name
        this.surveyObj.show = true
      } else this.jumpLinkSurveyPage(item) // Pc跳转实勘详情
    },
    openModule(v) {
      // 打开手机模块 grade
      if (!this.isMobile) return
      if (v == 'grade') this.mobile.grade = !this.mobile.grade
      if (v == 'env') this.mobile.env = !this.mobile.env
      if (v == 'aInfo') this.mobile.aInfo = !this.mobile.aInfo
    },
    jumpLinkSearchPage() {
      if (this.urlCodeList?.length == 3) return this.$toast(this.$v('最多支持3个交易商对比！'))
      if (this.urlNameList.includes(this.$cookies.get('compareAdCode'))) {
        this.urlCodeList.pop()
        this.urlNameList.pop()
      }
      const url = `/${this.LanguageCode}/compare/search?code=${this.urlCodeList}&name=${this.urlNameList}`
      setTimeout(() => {
        window.open(url)
      }, 300)
    },
    jumpLinkSurveyPage(item) {
      // 跳转实勘详情
      // console.log(item)
      if (item.sids?.split(',')[0]) {
        if (this.isMobile) window.open(`${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${item.code}.html`)
        else window.open(`${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/survey/${item.sids?.split(',')[0]}.html`)
      }
    },
    getMaxValue(arr) {
      const max = arr.sort(function (a, b) {
        return b - a
      })[0]
      return max
    },

    changeDom(v) {
      // 隐藏或者打开Dom
      if (!v) {
        this.isHidden.grade.score = true
        this.isHidden.grade.status = true
        this.isHidden.grade.status = true
        this.isHidden.grade.risk = true
        this.isHidden.grade.exposedTotal = true
        this.isHidden.grade.isEPC = true
        this.isHidden.grade.webSite = true

        this.isHidden.bInfo.established = true
        this.isHidden.bInfo.licensesItems = true
        this.isHidden.bInfo.existmt4 = true
        this.isHidden.bInfo.existmt5 = true
        this.isHidden.bInfo.existcurrency = true
        this.isHidden.bInfo.methods = true

        this.isHidden.env.Grade = true
        this.isHidden.env.SpeedGrade = true
        this.isHidden.env.AveSpeed = true
        this.isHidden.env.FastestSpeed = true
        this.isHidden.env.FastestSpeed_Open = true
        this.isHidden.env.FastestSpeed_Close = true
        this.isHidden.env.SlowestSpeed = true
        this.isHidden.env.SlowestSpeed_Open = true
        this.isHidden.env.SlowestSpeed_Close = true
        this.isHidden.env.SlipGrade = true
        // AveSlip_wh  AveSlip_xau
        this.isHidden.env.AveSlip.wh = true
        this.isHidden.env.AveSlip.xau = true
        this.isHidden.env.MaxSlip = true
        this.isHidden.env.MaxSlip_Positive = true
        this.isHidden.env.MaxSlip_Negative = true

        this.isHidden.env.CostGrade = true
        // AveCost_wh  AveCost_xau
        this.isHidden.env.AveCost.wh = true
        this.isHidden.env.AveCost.xau = true
        this.isHidden.env.SwapGrade = true
        // AveLongSwap_wh AveShortSwap_wh AveLongSwap_xau AveShortSwap_xau
        this.isHidden.env.AveLongSwap.wh = true
        this.isHidden.env.AveShortSwap.wh = true
        this.isHidden.env.AveLongSwap.xau = true
        this.isHidden.env.AveShortSwap.xau = true

        this.isHidden.env.OffLineGrade = true
        this.isHidden.env.AveReconnectNum = true
        this.isHidden.env.AveReconnectTime = true

        if (!this.hiddenElement) {
          document.getElementById('envSpeedBox').style.display = 'flex'
          document.getElementById('envSlipBox').style.display = 'flex'
          document.getElementById('envAveCostBox').style.display = 'flex'
          document.getElementById('envSwapGradeBox').style.display = 'flex'
          document.getElementById('envOffLineBox').style.display = 'flex'
        }

        this.isHidden.aInfo.allName = true
        this.isHidden.aInfo.accountName = true
        // allAccounts .accountName
        this.isHidden.aInfo.transactionType = true
        this.isHidden.aInfo.enterCondition = true
        this.isHidden.aInfo.maxLever = true
        this.isHidden.aInfo.mainSpread = true
        this.isHidden.aInfo.outStockRatio = true
        this.isHidden.aInfo.spreadType = true
        this.isHidden.aInfo.minCash = true
        this.isHidden.aInfo.cryptocurrency = true
        this.isHidden.aInfo.allowLock = true
        this.isHidden.aInfo.allowScalping = true
        this.isHidden.aInfo.allowE = true
      } else {
        /* 天眼评级 */
        const score = this.isSameFun(this.list, 'score')
        this.isHidden.grade.score = score
        const status = this.isSameFun(this.list, 'status')
        this.isHidden.grade.status = status
        const isEPC = this.isSameFun(this.list, 'isEPC')
        this.isHidden.grade.isEPC = isEPC
        const risk = this.isSameFun(this.list, 'risk')
        this.isHidden.grade.risk = risk
        const exposedTotal = this.isSameFun(this.list, 'exposedTotal')
        this.isHidden.grade.exposedTotal = exposedTotal
        const webSite = this.isSameFun(this.list, 'webSite')
        this.isHidden.grade.webSite = webSite
        /* 基本信息 */
        const established = this.isSameFun(this.list, 'established')
        this.isHidden.bInfo.established = established
        const licensesItems = this.isSameFun(this.list, 'licensesItems')
        this.isHidden.bInfo.licensesItems = licensesItems
        const existmt4 = this.isSameFun(this.list, 'existmt4')
        this.isHidden.bInfo.existmt4 = existmt4
        const existmt5 = this.isSameFun(this.list, 'existmt5')
        this.isHidden.bInfo.existmt5 = existmt5
        const existcurrency = this.isSameFun(this.list, 'existcurrency')
        this.isHidden.bInfo.existcurrency = existcurrency
        const methods = this.isSameFun(this.list, 'methods')
        this.isHidden.bInfo.methods = methods
        /** 交易环境 */

        const Grade = this.isSameFun(this.list, 'Grade')
        this.isHidden.env.Grade = Grade
        const SpeedGrade = this.isSameFun(this.list, 'SpeedGrade')
        this.isHidden.env.SpeedGrade = SpeedGrade
        const AveSpeed = this.isSameFun(this.list, 'AveSpeed')
        this.isHidden.env.AveSpeed = AveSpeed
        const FastestSpeed = this.isSameFun(this.list, 'FastestSpeed')
        this.isHidden.env.FastestSpeed = FastestSpeed
        const FastestSpeedOpen = this.isSameFun(this.list, 'FastestSpeed_Open')
        this.isHidden.env.FastestSpeed_Open = FastestSpeedOpen
        const FastestSpeedClose = this.isSameFun(this.list, 'FastestSpeed_Close')
        this.isHidden.env.FastestSpeed_Close = FastestSpeedClose
        const SlowestSpeed = this.isSameFun(this.list, 'SlowestSpeed')
        this.isHidden.env.SlowestSpeed = SlowestSpeed
        const SlowestSpeedOpen = this.isSameFun(this.list, 'SlowestSpeed_Open')
        this.isHidden.env.SlowestSpeed_Open = SlowestSpeedOpen
        const SlowestSpeedClose = this.isSameFun(this.list, 'SlowestSpeed_Close')
        this.isHidden.env.SlowestSpeed_Close = SlowestSpeedClose
        const SlipGrade = this.isSameFun(this.list, 'SlipGrade')
        this.isHidden.env.SlipGrade = SlipGrade

        // AveSlip_wh  AveSlip_xau
        const AveSlipwh = this.isSameFun(this.list, 'AveSlip_wh')
        this.isHidden.env.AveSlip.wh = AveSlipwh

        const AveSlipxau = this.isSameFun(this.list, 'AveSlip_xau')
        this.isHidden.env.AveSlip.xau = AveSlipxau

        const MaxSlip = this.isSameFun(this.list, 'MaxSlip')
        this.isHidden.env.MaxSlip = MaxSlip
        const MaxSlipPositive = this.isSameFun(this.list, 'GraMaxSlip_Positivede')
        this.isHidden.env.MaxSlip_Positive = MaxSlipPositive
        const MaxSlipNegative = this.isSameFun(this.list, 'MaxSlip_Negative')
        this.isHidden.env.MaxSlip_Negative = MaxSlipNegative
        const CostGrade = this.isSameFun(this.list, 'CostGrade')
        this.isHidden.env.CostGrade = CostGrade
        // AveCost_wh  AveCost_xau
        const AveCostwh = this.isSameFun(this.list, 'AveCost_wh')
        this.isHidden.env.AveCost.wh = AveCostwh
        const AveCostxau = this.isSameFun(this.list, 'AveCost_xau')
        this.isHidden.env.AveCost.xau = AveCostxau

        const SwapGrade = this.isSameFun(this.list, 'SwapGrade')
        this.isHidden.env.SwapGrade = SwapGrade
        // AveLongSwap_wh AveShortSwap_wh AveLongSwap_xau AveShortSwap_xau

        const AveLongSwapwh = this.isSameFun(this.list, 'AveLongSwap_wh')
        this.isHidden.env.AveLongSwap.wh = AveLongSwapwh
        const AveShortSwapwh = this.isSameFun(this.list, 'AveShortSwap_wh')
        this.isHidden.env.AveShortSwap.wh = AveShortSwapwh
        const AveLongSwapxau = this.isSameFun(this.list, 'AveLongSwap_xau')
        this.isHidden.env.AveLongSwap.xau = AveLongSwapxau
        const AveShortSwapxau = this.isSameFun(this.list, 'AveShortSwap_xau')
        this.isHidden.env.AveShortSwap.xau = AveShortSwapxau
        // 断线情况
        const OffLineGrade = this.isSameFun(this.list, 'OffLineGrade')
        this.isHidden.env.OffLineGrade = OffLineGrade
        const AveReconnectNum = this.isSameFun(this.list, 'AveReconnectNum')
        this.isHidden.env.AveReconnectNum = AveReconnectNum
        const AveReconnectTime = this.isSameFun(this.list, 'AveReconnectTime')
        this.isHidden.env.AveReconnectTime = AveReconnectTime
        // 账户信息
        const allName = this.isSameFun(this.list, 'allName')
        this.isHidden.aInfo.allName = allName

        // const accountName = this.isSameFun(this.aInfoAccountList)
        const accountName = this.isSameFun(this.aInfoAccountList, 'accountName')
        this.isHidden.aInfo.accountName = accountName

        const transactionType = this.isSameFun(this.aInfoAccountList, 'transactionType')
        this.isHidden.aInfo.transactionType = transactionType
        const enterCondition = this.isSameFun(this.aInfoAccountList, 'enterCondition')
        this.isHidden.aInfo.enterCondition = enterCondition
        const maxLever = this.isSameFun(this.aInfoAccountList, 'maxLever')
        this.isHidden.aInfo.maxLever = maxLever
        const mainSpread = this.isSameFun(this.aInfoAccountList, 'mainSpread')
        this.isHidden.aInfo.mainSpread = mainSpread
        const outStockRatio = this.isSameFun(this.aInfoAccountList, 'outStockRatio')
        this.isHidden.aInfo.outStockRatio = outStockRatio
        const spreadType = this.isSameFun(this.aInfoAccountList, 'spreadType')
        this.isHidden.aInfo.spreadType = spreadType
        const minCash = this.isSameFun(this.aInfoAccountList, 'minCash')
        this.isHidden.aInfo.minCash = minCash
        const cryptocurrency = this.isSameFun(this.aInfoAccountList, 'cryptocurrency')
        this.isHidden.aInfo.cryptocurrency = cryptocurrency
        const allowLock = this.isSameFun(this.aInfoAccountList, 'allowLock')
        this.isHidden.aInfo.allowLock = allowLock
        const allowScalping = this.isSameFun(this.aInfoAccountList, 'allowScalping')
        this.isHidden.aInfo.allowScalping = allowScalping
        const allowEA = this.isSameFun(this.aInfoAccountList, 'allowEA')
        this.isHidden.aInfo.allowEA = allowEA
      }
    },
    hiddenElementFun(v) {
      // 隐藏相同的
      if (this.urlCodeList.length < 2) {
        this.isLastTrader = true
        this.isAicontentShow = true
        this.changeDom(false)
        return
      }
      if (process.client && this.hiddenElement && v) {
        this.loading = true
        if (this.isMobile) {
          this.mobile.env = true
          this.mobile.aInfo = true
          this.mobile.grade = true
        }
      }
      this.changeDom(v)
      if (process.client && this.hiddenElement && v) {
        setTimeout(() => {
          const envSpeedHeight = document.getElementById('envSpeed').offsetHeight
          document.getElementById('envSpeedType').style.height = envSpeedHeight + 'px'
          if (envSpeedHeight == 0) document.getElementById('envSpeedBox').style.display = 'none'

          const envSlipHeight = document.getElementById('envSlip').offsetHeight
          document.getElementById('envSlipType').style.height = envSlipHeight + 'px'
          if (envSlipHeight == 0) document.getElementById('envSlipBox').style.display = 'none'

          const envAveCostHeight = document.getElementById('envAveCost').offsetHeight
          document.getElementById('envAveCostType').style.height = envAveCostHeight + 'px'
          if (envAveCostHeight == 0) document.getElementById('envAveCostBox').style.display = 'none'

          const envSwapGradeHeight = document.getElementById('envSwapGrade').offsetHeight
          document.getElementById('envSwapGradeType').style.height = envSwapGradeHeight + 'px'
          if (envSwapGradeHeight == 0) document.getElementById('envSwapGradeBox').style.display = 'none'

          const envOffLineHeight = document.getElementById('envOffLine').offsetHeight
          document.getElementById('envOffLineType').style.height = envOffLineHeight + 'px'
          if (envOffLineHeight == 0) document.getElementById('envOffLineBox').style.display = 'none'

          this.loading = false
        }, 1000)
      }
    },

    isSameFun(arr, key) {
      if (arr.length > 3) arr = arr.slice(0, 3)
      if (!arr[2]?.code) arr = arr.slice(0, 2)
      // 获取数组中第一个对象的key的值
      const firstValue = arr[0][key] == '0.00' || arr[0][key] == '0.0' || arr[0][key] == '0' || !arr[0][key] ? '--' : arr[0][key]

      // 遍历数组，检查每个对象的key的值是否与第一个值相同
      for (let i = 1; i < arr.length; i++) {
        let newKey = arr[i][key]
        if (newKey == '0.00' || newKey == '0.0' || newKey == '0' || !newKey) newKey = '--'
        if (newKey != firstValue) {
          return true // 如果有不相同的值，返回false
        }
      }
      return false // 如果所有值都相同，返回true
    },

    // getshortName (n1, n2) {
    //   return getshortName(n1, n2)
    // },
    getAtArr() {
      const traderParams = trader
      const atArr1 = []
      const atArr2 = []
      const atArr3 = []
      if (this.urlCodeList.length > 1) {
        const rankOne = traderParams.findIndex((item) => {
          return item.name == this.urlNameList[0]
        })

        const rankTwo = traderParams.findIndex((item) => {
          return item.name == this.urlNameList[1]
        })

        if (rankOne > rankTwo) {
          // console.log('rankOne >  rankTwo')
        }
        const traderArr = traderParams.filter((item) => {
          return item.name != this.urlNameList[0] && item.name != this.urlNameList[1]
        })
        const mathIndex = rankTwo + 1
        this.atArr = traderArr.slice(mathIndex)
        if (this.urlCodeList.length == 3) {
          const rankThree = traderParams.findIndex((item) => {
            return item.name == this.urlNameList[2]
          })
          const traderArr = traderParams.filter((item) => {
            return item.name != this.urlNameList[0] && item.name != this.urlNameList[1] && item.name != this.urlNameList[2]
          })
          const mathIndex = rankThree + 1
          this.atArr = traderArr.slice(mathIndex)
        }
        this.atArr.slice(0, 6).forEach((el) => {
          atArr1.push({
            code: el.code,
            name: el.name,
            urlName: this.urlNameList[0]
          })
          atArr2.push({
            code: el.code,
            name: el.name,
            urlName: this.urlNameList[1]
          })
          if (this.urlNameList[2]) {
            atArr3.push({
              code: el.code,
              name: el.name,
              urlName: this.urlNameList[2]
            })
          }
        })
      }
      this.atArr = [...atArr1, ...atArr2, ...atArr3]
    },
    chooseAccount(i, index) {
      this.accountsIndex.splice(i, 1, index)
      if (this.hiddenElement) this.hiddenElementFun(true)
    },
    // 获取交易商详情内容
    async getdealerInfo(traderCodes) {
      console.log('traderCodes::: ', traderCodes)
      if (traderCodes.length === 0) return
      // 判断是否为更新中
      const updatingRes = await this.$api.common
        .CV3(
          {
            traderCode: traderCodes[0]
          },
          { Routes: ' wikifxagg$trader_updating_toast' }
        )
        .catch(() => {
          console.log('wikifxagg$trader_updating_toast------error')
        })
      const toastData = updatingRes?.wikifxagg?.trader_updating_toast?.data
      console.log('toastData::: ', toastData)
      console.log(this.autocompleteValue, 'autocompleteValue')
      if (toastData) this.autocompleteValue = ['', '', '', '', '']
      if (toastData)
        return this.$message({
          message: toastData,
          type: 'warning',
          customClass: 'vs-toast'
        })

      this.loading = true
      const elUrlNameList = []
      await this.$api.compare
        .clientGetUrlName({ codes: traderCodes.toString() })
        .then((res) => {
          console.log('res::: ', res)
          if (res?.length) {
            res &&
              res.forEach((el) => {
                elUrlNameList.push({
                  TraderCode: el.TraderCode,
                  urlName: el.Name
                })
              })
          } else {
            this.loading = false
            return false
          }
        })
        .catch(() => {
          console.log('客户端获取urlName错误')
          this.autocompleteValue.splice(this.tabIndex, 1, '')
          this.$message.error('Error')
          this.loading = false
        })

      if (elUrlNameList.length == 0) return
      // else this.loading = false

      const res = await this.$api.compare
        .compare({
          traderCodes,
          ip: this.$store.state.userIp,
          period: 2,
          isWeb: 1,
          platformType: 2,
          index: 1,
          size: 20
        })
        .catch(() => {
          console.log('compare,客户端交易商对比接口错误')
          this.loading = false
        })
      if (!res) {
        return
      }
      this.addUrlName(elUrlNameList[0].urlName, elUrlNameList[0].TraderCode)
      this.autocompleteValue.splice(this.tabIndex, 1, '')
      const traderInfo = res.TraderInfoResponse || []
      const infoData = res.TradeBrokersContrastResponse || []
      // 实勘好评
      const traderCount = res.TraderCountResponse.items || []
      const exposedTraderList = res.ExposedTraderList || []
      const MultipleTrader = res.MultipleTrader || []
      const TraderArticles = res.TraderArticles || []
      const TraderIntros = res.TraderIntros || []
      const exposedTotal = []
      exposedTraderList.forEach((el) => {
        // console.log(el, 'el456')
        exposedTotal.push({ exposedTotal: el.count })
      })
      const list = traderInfo.map((item, index) => {
        return {
          ...elUrlNameList[index],
          ...infoData[index],
          ...MultipleTrader[index],
          ...TraderArticles[index],
          ...TraderIntros[index],
          ...traderCount[index],
          ...exposedTotal[index],
          ...item
        }
      })
      // this.list.splice(this.tabIndex, 1, list[0])
      let AdIndex = 0
      let AdinList = false
      list.forEach((el, i) => {
        const emptyLlist = []
        el.accounts &&
          el.accounts.forEach((val) => {
            emptyLlist.push(val.accountName)
          })
        const licensesList = []
        el.basic?.licenses?.forEach((item) => {
          licensesList.push(item.shortName)
        })
        const first = this.list[0]?.score
        const second = this.list[1]?.score
        // const third = this.list[2] && this.list[2].score
        if (!second) {
          this.tabIndex = 1
        }
        if (!first) {
          this.tabIndex = 0
        }

        this.list.forEach((el, index) => {
          if (el.AdSlogan) {
            AdIndex = index
            AdinList = true
          }
        })

        // this.dealerNameList.push(this.getshortName(el.shortName, el.localshortname))
        this.dealerNameList.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, this.getOnlyShortName(el.shortName, el.localshortname)).slice(0, 3)
        this.list.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, {
          hitsInfo: el.hitsInfo,
          shortName: el.shortName,
          localshortname: el.localshortname,
          icon: el.icon,
          urlName: el.urlName,
          content: el.content,
          summary: el.summary,
          TraderArticles: el.TraderArticles || null,
          MultipleTrader: el.MultipleTraderExposure || null,
          exposedTotal: el.exposedTotal || 0,
          surveyList: el.list || [],
          code: el.code || el.TraderCode,
          logo: el.logo,
          // 天眼评分
          score: ((el.rating && el.rating.score) * 1).toFixed(2) || '--',
          status: el.rating.status || '--',
          isEPC: el?.rating.isEPC == 'true' ? '保障中' : '无保障',
          risk: el.rating.risk || 0,
          webSite: el.rating.webSite || '--', // 网址
          // 基本信息
          established: el.basic.established || '--',
          licensesItems: licensesList.toString() || '--',
          existmt4: el.basic.existmt4.toString() == 'true' ? 1 : 0,
          existmt5: el.basic.existmt5.toString() == 'true' ? 1 : 0,
          existcurrency: el.basic.existcurrency.toString() == 'true' ? 1 : 0,
          methods: el.basic.methods || '--',
          // 交易环境
          Grade: el.Grade || '--',
          SpeedGrade: el.SpeedGrade || '--',
          AveSpeed: el.AveSpeed || '--',
          FastestSpeed: el.FastestSpeed || '--',
          FastestSpeed_Open: el.FastestSpeed_Open || '--',
          FastestSpeed_Close: el.FastestSpeed_Close || '--',
          SlowestSpeed: el.SlowestSpeed || '--',
          SlowestSpeed_Open: el.SlowestSpeed_Open || '--',
          SlowestSpeed_Close: el.SlowestSpeed_Close || '--',
          // 交易滑点
          SlipGrade: el.SlipGrade || '--',
          AveSlip_wh: el.AveSlip_wh || '--',
          AveSlip_xau: el.AveSlip_xau || '--',
          MaxSlip: el.MaxSlip || '--',
          MaxSlip_Positive: el.MaxSlip_Positive || '--',
          MaxSlip_Negative: el.MaxSlip_Negative || '--',
          // 交易成本
          CostGrade: el.CostGrade || '--',
          AveCost_wh: el.AveCost_wh || '--',
          AveCost_xau: el.AveCost_xau || '--',
          // 隔夜成本
          SwapGrade: el.SwapGrade || '--',
          AveLongSwap_wh: el.AveLongSwap_wh || '--',
          AveShortSwap_wh: el.AveShortSwap_wh || '--',
          AveLongSwap_xau: el.AveLongSwap_xau || '--',
          AveShortSwap_xau: el.AveShortSwap_xau || '--',
          // 断线情况
          OffLineGrade: el.OffLineGrade || '--',
          AveReconnectNum: el.AveReconnectNum || '--',
          AveReconnectTime: el.AveReconnectTime || '--',
          // 账户信息
          accountName: (el.accounts && el.accounts[0] && el.accounts[0].accountName) || '--',
          allAccounts: el.accounts || [
            {
              accountName: '--',
              transactionType: '--',
              enterCondition: '--',
              maxLever: '--',
              mainSpread: '--',
              outStockRatio: '--',
              spreadType: '--',
              minCash: '--',
              allowLock: '--',
              allowScalping: '--',
              allowEA: '--',
              cryptocurrency: '--'
            }
          ], // 数组 所有账户
          allName: emptyLlist.toString() || '--'
          // allAccountsType: el.accounts.forEach((el) => { return allAccountsType.push(el.accountName) }) || '--'
        })
      })
      // console.log(this.list, 'list')
      if (this.list.length > 3) this.list.slice(0, 3)
      this.loading = false
      this.isAiLoad = false
      // this.loadScript()
      this.initAiData()
      if (this.hiddenElement) this.hiddenElementFun(true)
      this.getAtArr()
    },

    onScrolls() {
      if (this.isMobile) return
      // const a = document.getElementById('first-floor')?.getBoundingClientRect().top
      const b = document.getElementById('second-floor').getBoundingClientRect().top
      const c = document.getElementById('third-floor').getBoundingClientRect().top
      const d = document.getElementById('fourth-floor').getBoundingClientRect().top
      const e = document.getElementById('fifth-floor')?.getBoundingClientRect().top
      const f = document.getElementById('six-floor')?.getBoundingClientRect().top // 相关资讯/曝光
      const g = document.getElementById('seven-floor')?.getBoundingClientRect().top // 相关曝光

      // 调整索引计算逻辑，不考虑已注释掉的对比总结菜单项
      if (b > 320) {
        this.isActived = 0 // 天眼评级
      } else if (b <= 320 && c > 320) {
        this.isActived = 0 // 基本信息
      } else if (c <= 320 && d > 320) {
        this.isActived = 1 // 交易环境
      } else if (d <= 320 && e > 320) {
        this.isActived = 2 // 账户信息
      } else if (e <= 320 && f > 162) {
        this.isActived = 3 // 相关资讯/账户信息
      } else if (f <= 162 && g > 162 && this.setTabList.length > 5) {
        this.isActived = 4 // 相关资讯/曝光
      } else if (g <= 162 && this.setTabList.length > 5) {
        this.isActived = 5 // 相关曝光
      } else {
        // 根据setTabList长度设置默认激活索引
        switch (this.setTabList.length) {
          case 5:
            this.isActived = 3
            break
          case 6:
            this.isActived = 4
            break
          case 7:
            this.isActived = 5
            break
          default:
            this.isActived = this.setTabList.length - 1
        }
      }
    },
    // 切换TabList - 优化后代码
    chooseTab(type, selector) {
      // 调试：确认点击事件被触发
      console.log('chooseTab clicked with type:', type)
      
      // 防御性检查：确保type有效
      if (type === undefined) {
        console.warn('Invalid tab type provided')
        return
      }

      // 根据type找到对应的tab索引
      const tabIndex = this.setTabList.findIndex((item) => item.type === type)

      // 如果找不到对应的tab，不进行后续操作
      if (tabIndex === -1) {
        console.warn(`Tab with type ${type} not found`)
        return
      }

      // 处理长语言下的标签栏滚动
      if (this.isLongLanguage) {
        const tabsBox = document.getElementById('tabs-box')
        if (tabsBox) {
          tabsBox.scrollTo({
            left: tabIndex > 3 ? 100 : 0,
            behavior: 'smooth'
          })
        }
      }

      // 设置当前激活的tab索引(兼容旧逻辑)
      this.isActived = tabIndex
      // 设置当前激活的tab类型(新逻辑)
      this.activeTabType = type

      // 使用映射表替代长串的if-else，提高可维护性
      const typeToSelector = {
        0: '#first-floor',
        1: '#second-floor',
        2: '#third-floor',
        3: '#fourth-floor',
        4: '#fifth-floor',
        5: '#six-floor',
        6: '#seven-floor'
      }

      // 获取选择器，如果映射表中不存在则使用默认值
      selector = typeToSelector[type] || selector
      this.selector = selector

      // 执行滚动逻辑
      if (selector) {
        if (type === 1) { // 之前的代码 是 type = 0 回到顶部 目前 type 等于 0 的菜单 先注释掉了 （后面还会加）
          // 对比总结特殊处理：直接滚动到页面顶部
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        } else {
          // 其他标签正常滚动到对应的锚点
          const anchor = this.$el.querySelector(selector)
          if (anchor) {
            anchor.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'center'
            })
          } else {
            console.warn(`Element with selector ${selector} not found`)
          }
        }
      }

      // 关闭移动端tab列表
      this.isShowMobileTabList = false
    },
    // 搜索 async
    async querySearch(queryString, cb) {
      // console.log(this.rankList, '排行榜数据')
      let restaurants = []
      if (queryString) {
        // 智能搜索
        this.$api.compare
          .compareSearch({
            content: queryString,
            project: 1,
            type: 1,
            product: 2,
            isInternational: false,
            isMinal: false,
            isApp: false
          })
          .then((res) => {
            restaurants = []
            res.items &&
              res.items.forEach((el) => {
                if (!this.urlCodeList.toString().includes(el.code)) {
                  restaurants.push({
                    value: el.shortName || el.englishShortName,
                    ico: el.ico,
                    code: el.code,
                    urlName: el.urlName,
                    logo: el.logo
                  })
                }
              })
            cb(restaurants)
          })
          .catch(() => {
            console.log('智能搜索错误')
          })
      } else {
        restaurants = []
        await this.rankList.forEach((el) => {
          if (!this.urlCodeList.toString().includes(el.code)) {
            restaurants.push(el)
          }
        })
        cb(restaurants)
      }
    },
    handleSelect(item) {
      const code = item.code.split()
      this.getdealerInfo(code)
      // this.getUrlName(item.code) // 添加urlName
    },
    // 在url 上添加交易商urlName
    addUrlName(name, code, isFirst = false) {
      const num = this.urlNameList.length
      if (!isFirst) {
        let AdIndex = 0
        let AdinList = false
        this.list.forEach((el, index) => {
          if (el.AdSlogan) {
            AdIndex = index
            AdinList = true
          }
        })

        this.urlNameList.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, name).slice(0, 3)
        this.urlCodeList.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, code).slice(0, 3)
        // this.urlNameList.push(name)
        // this.urlCodeList.push(code)
      }

      const params = this.urlNameList.join('-vs-')
      let newUrl = `/${this.$store.state.LanguageCode}/compare`
      if (num > 0) newUrl = `/${this.$store.state.LanguageCode}/compare/` + params
      // history.replaceState(null, null, newUrl)
      // history.pushState(0, '0', newUrl)
      window.history.pushState({ path: newUrl }, '', newUrl)
      this.$store.commit('setPath', 'compare/' + params || '')
    },
    pinnedLeft(val, i) {
      // 钉住在左侧
      const dom = document.getElementById('dealerIndex0')
      if (this.isPinnedLeft && i == 0) {
        this.isPinnedLeft = !this.isPinnedLeft
        dom.style = 'position:relative !important; left:unset; z-index: unset;'
      } else {
        this.pinnedLeftIndex = i
        this.isPinnedLeftCode = val.code
        this.isPinnedLeft = true

        this.list.splice(i, 1)
        this.list.unshift(val)

        const dealerName = this.dealerNameList[i]
        this.dealerNameList.splice(i, 1)
        this.dealerNameList.unshift(dealerName)

        const name = this.urlNameList[i]
        this.urlNameList.splice(i, 1)
        this.urlNameList.unshift(name)

        const code = this.urlCodeList[i]
        this.urlCodeList.splice(i, 1)
        this.urlCodeList.unshift(code)

        // console.log(dom)
        if (this.LanguageCode == 'ar') {
          if (this.isMobile) {
            // dom.style = 'position:sticky !important; right:0;  z-index: 12;'
          } else {
            // dom.style = 'position:sticky !important; right:360px; z-index: 12;'
          }
        } else {
          // dom.style = 'position:sticky !important; left:0px; z-index: 12;'
        }
      }
    },
    // 关闭
    close(index, item) {
      // 如果getAiData接口正在请求中，阻止执行close方法
      if (this.isGetAiDataLoading) return

      if (!item.code) return
      if (this.urlNameList.length && this.list.length > 3) {
        this.list.splice(index, 1)
      } else {
        this.list.splice(index, 1)
        this.list.push({})
      }
      const arr = []
      this.atArr.forEach((el) => {
        if (el.urlName != item.urlName) {
          arr.push(el)
        }
      })
      this.atArr = arr
      this.delUrlName(item.urlName, item.code, this.getOnlyShortName(item.shortName, item.localshortname)) // 获取urlName,并且删除urlName
      if (this.hiddenElement) this.hiddenElementFun(true)
      this.isAiLoad = false
      // this.loadScript()
      this.initAiData()
    },
    // 删除urlName
    delUrlName(name, code, dealerName) {
      if (name)
        this.urlNameList.splice(
          this.urlNameList.findIndex((item) => item === name),
          1
        )
      if (code)
        this.urlCodeList.splice(
          this.urlCodeList.findIndex((item) => item === code),
          1
        )
      if (dealerName)
        this.dealerNameList.splice(
          this.dealerNameList.findIndex((item) => item === dealerName),
          1
        )
      const params = this.urlNameList.join('-vs-')
      let newUrl = `/${this.$store.state.LanguageCode}/compare/`
      if (this.urlNameList.length > 0) newUrl = `/${this.$store.state.LanguageCode}/compare/${params}`
      window.history.pushState({ path: newUrl }, '', newUrl)
      this.$store.commit('setPath', 'compare/' + params || '')
    },
    // 选择交易商的索引
    inputIndex(index) {
      if (!index) {
        return
      }
      this.tabIndex = index
      this.isShowMobileTabList = false
    },
    getRankList() {
      // 获取排行榜前20
      this.$api.home
        .invokev3(
          {
            languageCode: this.$store.state.LanguageCode,
            countryCode: this.$store.state.CountryCode
          },
          {
            Routes: 'wikifx$traderexpandlist'
          }
        )
        .catch(() => {
          console.log('compare[getRankList],交易商对比rank接口错误')
        })
        .then((res) => {
          const expandlist = res && res.wikifx && res.wikifx.traderexpandlist && res.wikifx.traderexpandlist.data && res.wikifx.traderexpandlist.data.length > 0
          // console.log(expandlist, '排行榜')
          if (expandlist && expandlist.length > 0) {
            expandlist.forEach((el) => {
              if (!this.urlCodeList.includes(el.traderCode)) {
                this.rankList.push({
                  value: el.shortName,
                  code: el.traderCode || el.code,
                  ico: el.ico,
                  logo: el.logo,
                  name: el.localShortName
                })
              }
            })
          }
        })
    },
    // 获取实勘内容
    getSurvey(code, num) {
      const lang = this.$store.state.LanguageCode
      let text = '--'
      if (code == '8001') {
        text = lang == 'zh-cn' ? '精品' : lang == 'zh' ? '精品' : 'Perfect'
      } else if (code == '8002') {
        text = lang == 'zh-cn' ? '好评' : lang == 'zh' ? '好評' : 'Great'
      } else if (code == '8003') {
        text = lang == 'zh-cn' ? '良好' : lang == 'zh' ? '良好' : 'Good'
      } else if (code == '8004') {
        text = lang == 'zh-cn' ? '差评' : lang == 'zh' ? '差评' : 'Danger'
      } else if (code == '8005') {
        text = lang == 'zh-cn' ? 'VR' : lang == 'zh' ? 'VR' : 'VR'
      } else if (code == '8006') {
        text = lang == 'zh-cn' ? '一般' : lang == 'zh' ? '一般' : 'Average'
      } else {
        text = '--'
      }
      const unit = lang == 'zh-cn' ? '条' : lang == 'zh' ? '條' : ''
      const txt = lang == 'zh-cn' || lang == 'zh' ? text + ' ' + num + ' ' + unit : num + ' ' + text
      return txt
    },
    getRisk(num) {
      // 风险测评和天眼曝光
      if (num) {
        return this.$v('{0}条').replace(/\{0\}/g, num)
      } else {
        return ''
      }
    },
    // 处理链接点击事件，针对“公司网址”这一项调用接口判断是否直接跳转
    handleLink(e = {}, obj = {}) {
      const { code, webSite } = obj || {}
      e?.preventDefault()
      const { allHost, user, LanguageCode: locale, CountryCode: nationCode, userIp } = this.$store.state
      this.$api.common
        .CV3(
          {
            type: 1, // 1交易商，3代理商，5自营交易商
            code,
            spots: 1,
            url: webSite,
            platform: 3,
            apptype: 0,
            equipId: this.$Cookie.get('wiki-bfp'),
            jumpStatisticsUrl: allHost,
            lang: locale,
            country: nationCode,
            userid: user.userId || '0',
            ip: userIp
          },
          { Routes: 'statistics$tradercountv3' }
        )
        .then((res) => {
          const { isShowNotFound, type: category, url: apiLink } = res?.statistics?.tradercountv3?.data || {}
          this.companyWebsite = webSite
          this.returnWebsite = apiLink
          if (isShowNotFound) {
            const hintDom = this.$refs?.noteDom
            hintDom?.unableAccess(true)
            hintDom?.open()
          } else if (this.tips?.title) {
            this.moduleShow = true
            this.tipsType = String(category)
            const delayTimer = setTimeout(() => {
              clearTimeout(delayTimer)
              this.$refs?.riskDom?.open()
            }, 0)
          } else this.nextToDo(category)
        })
        .catch(() => {})
    },
    // 关闭“特别提示”弹框
    closeRiskDialog() {
      this.moduleShow = false
      this.modelShow = false
    },
    // 关闭弹框后需要的操作
    nextToDo(val = 0) {
      if (val == '0') {
        this.modelShow = true
        this.$refs?.noteDom?.open()
      } else if (val == '1') {
        const returnUrl = this.returnWebsite
        const { mobile, LanguageCode: locale } = this.$store.state
        if (!returnUrl?.includes('mobile/tradertips')) {
          const delayTimer = setTimeout(
            () => {
              clearTimeout(delayTimer)
              createJump(returnUrl)
            },
            mobile ? 400 : 0
          )
          this.closeRiskDialog()
        } else if (returnUrl?.includes('flgship=1')) {
          const delayTimer = setTimeout(
            () => {
              clearTimeout(delayTimer)
              createJump(`/${locale}/warning.html?url=${this.companyWebsite}`)
            },
            mobile ? 400 : 0
          )
        } else if (returnUrl?.includes('flgship=0')) {
          this.modelShow = true
          this.$refs?.noteDom?.open()
        }
      }
      // 创建跳转链接
      function createJump(url = '') {
        const a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('target', '_blank')
        a.setAttribute('id', 'startTelMedicine')
        if (document.getElementById('startTelMedicine')) {
          document.body.removeChild(document.getElementById('startTelMedicine')) // 防止反复添加
        }
        document.body.appendChild(a)
        a.click()
      }
    },
    // 获取对比ai数据
    getAiData(row) {
      // 防抖逻辑：清除之前的计时器
      if (this.getAiDataDebounceTimer) {
        clearTimeout(this.getAiDataDebounceTimer)
      }
      this.isGetAiDataLoading = true // 设置请求开始标志
      const { list } = this
       const _traderCodes = []
        list.forEach((el) => {
          if (el.code) {
            _traderCodes.push(el.code)
          }
        })
       if (_traderCodes.length < 2) {
          this.isGetAiDataLoading = false
          return
        }
      // 设置新的计时器，延迟4秒执行
      this.getAiDataDebounceTimer = setTimeout(() => {
        this.isAiLoad = false
        this.aiData = {}
        this.$api.common
          .CV3(
            {
              rows: row.rows,
              traderCodes: _traderCodes
            },
            {
              Routes: 'wikiai$v1aitradercomparison'
            }
          )
          .then((res) => {
            this.aiData = res.wikiai?.v1aitradercomparison?.data
            this.feedbackList = this.aiData?.feedback?.items || []
            console.log(this.aiData, 'aiData')
            if (this.aiData?.has_feedback) {
              this.isAiLike = this.aiData?.like
              this.isFeedback = !this.aiData?.like
            } else {
              this.isAiLike = false
              this.isFeedback = false
            }
          })
          .finally(() => {
            if (!this.aiData?.overview) {
              this.isAicontentShow = false
            }
            this.isAiLoad = true
            this.isGetAiDataLoading = false // 请求完成（成功或失败）后清除标志
          })
      }, 4000) // 4秒防抖延迟
    }
  }
}
